/**
 * Parse the language options into a standard object format.
 * Map the key to the text value of each language.
 *
 * @param {array} mappedValues
 * @param {array} languages
 */
export const formatLanguageData = (mappedValues = [], languages = []) => {
  const languageOptions = languages.map(option => {
    return {
      key: String(option.Id),
      value: String(option.Id),
      text: option.Description,
    };
  });

  let languageDataMapped = {};
  languageOptions.forEach(o => {
    languageDataMapped[o.key] = o.text;
  });

  const finalMappedList = formatMappingData(
    mappedValues,
    languageDataMapped,
    1
  );

  return [languageOptions, languageDataMapped, finalMappedList];
};

/**
 * Map the stored meal mapping data to the fixtured meal data.
 *
 * @param {array} mappedValues
 * @param {array} mealsDataMapped
 */
export const formatMealData = (mappedValues = [], mealsDataMapped = []) =>
  formatMappingData(mappedValues, mealsDataMapped, 2);

/**
 * Generate mapping data for mapping import values from
 * an external source to an internal source.
 *
 * For example map the user's withdrawn meal status of W
 * to the internal API meal status of 5
 *
 * @param {array} mappedValues
 * @param {array} dataMap
 * @param {int} typeId
 */
export const formatMappingData = (
  mappedValues = [],
  dataMap = [],
  typeId = 1
) =>
  mappedValues.map(value => ({
    ExternalField: value.ExternalField,
    mappedValue: dataMap[value.InternalField],
    InternalField: value.InternalField,
    MappingTypeId: typeId,
  }));



// WEBPACK FOOTER //
// ./src/pages/importstudents/ImportSettingsHelper.js